module.exports = __webpack_public_path__ + "img/alliance.0be29a19.png";